import { render, staticRenderFns } from "./ModalZendai.vue?vue&type=template&id=fb13ad6e&"
import script from "./ModalZendai.vue?vue&type=script&lang=js&"
export * from "./ModalZendai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports